import { FunctionComponent } from "react";
import { Link } from "react-router-dom";
import { useTranslate } from "../locales/hooks";

const PrivacyPage: FunctionComponent = () => {
  const t = useTranslate();

  return (
    <div className="flex h-full min-h-0 w-full items-start justify-center overflow-y-auto px-[20px] py-[20px]">
      <article className="w-[min(92vw,680px)] rounded-2xl border border-slate-200 bg-white p-8 shadow-[0_8px_24px_rgba(15,23,42,0.08)]">
        <h1 className="font-['Hind',sans-serif] text-[26px] font-bold leading-tight text-slate-900">
          {t("privacyPage__title")}
        </h1>

        <p className="mt-4 text-sm leading-6 text-slate-700">
          {t("privacyPage__intro")}
        </p>

        <section className="mt-6">
          <h2 className="text-[15px] font-semibold text-slate-900">
            {t("privacyPage__basisTitle")}
          </h2>
          <p className="mt-2 text-sm leading-6 text-slate-700">
            {t("privacyPage__basis")}
          </p>
        </section>

        <section className="mt-6">
          <h2 className="text-[15px] font-semibold text-slate-900">
            {t("privacyPage__dataTitle")}
          </h2>
          <ul className="mt-2 flex list-disc flex-col gap-2 pl-5 text-sm leading-6 text-slate-700">
            <li>{t("privacyPage__dataAccount")}</li>
            <li>{t("privacyPage__dataInterview")}</li>
            <li>{t("privacyPage__dataAnalytics")}</li>
          </ul>
        </section>

        <section className="mt-6">
          <h2 className="text-[15px] font-semibold text-slate-900">
            {t("privacyPage__purposesTitle")}
          </h2>
          <p className="mt-2 text-sm leading-6 text-slate-700">
            {t("privacyPage__purposes")}
          </p>
        </section>

        <section className="mt-6">
          <h2 className="text-[15px] font-semibold text-slate-900">
            {t("privacyPage__processorsTitle")}
          </h2>
          <ul className="mt-2 flex list-disc flex-col gap-2 pl-5 text-sm leading-6 text-slate-700">
            <li>{t("privacyPage__processorsInterview")}</li>
            <li>{t("privacyPage__processorsAnalytics")}</li>
          </ul>
        </section>

        <section className="mt-6">
          <h2 className="text-[15px] font-semibold text-slate-900">
            {t("privacyPage__interviewDataTitle")}
          </h2>
          <p className="mt-2 text-sm leading-6 text-slate-700">
            {t("privacyPage__interviewData")}
          </p>
        </section>

        <section className="mt-6">
          <h2 className="text-[15px] font-semibold text-slate-900">
            {t("privacyPage__storageTitle")}
          </h2>
          <p className="mt-2 text-sm leading-6 text-slate-700">
            {t("privacyPage__storage")}
          </p>
        </section>

        <section className="mt-6">
          <h2 className="text-[15px] font-semibold text-slate-900">
            {t("privacyPage__rightsTitle")}
          </h2>
          <p className="mt-2 text-sm leading-6 text-slate-700">
            {t("privacyPage__rights")}
          </p>
        </section>

        <section className="mt-6">
          <h2 className="text-[15px] font-semibold text-slate-900">
            {t("privacyPage__consentTitle")}
          </h2>
          <p className="mt-2 text-sm leading-6 text-slate-700">
            {t("privacyPage__consent")}
          </p>
        </section>

        <div className="mt-8">
          <Link
            to="/"
            className="text-sm underline underline-offset-4 hover:text-slate-900"
          >
            {t("privacyPage__backHome")}
          </Link>
        </div>
      </article>
    </div>
  );
};

export default PrivacyPage;
